import axios from "axios";

export type GetAllParams = {
  limit?: number;
  page?: number;
  sort?: string;
  "filter[search]"?: string;
  "filter[filter]"?: string;
  "filter[type]"?: string;
  "filter[status]"?: string;
  "filter[app]"?: string;
  "filter[name]"?: string;
  "filter[lora_id]"?: null | number;
  include?: string;
};

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

api.interceptors.request.use(
  (config) => {
    config.headers.Accept = "application/json";
    const token = localStorage.getItem("token");
    const impersonatingUserId = localStorage.getItem("impersonating_user_id");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (impersonatingUserId) {
      config.headers.Impersonation = impersonatingUserId;
    }

    const event = new CustomEvent("axios:loading", { detail: true });
    document.dispatchEvent(event);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => {
    const event = new CustomEvent("axios:loading", { detail: false });
    document.dispatchEvent(event);
    return response;
  },
  (error) => {
    const event = new CustomEvent("axios:loading", { detail: false });
    document.dispatchEvent(event);
    return Promise.reject(error);
  },
);

// Export the api instance
export default api;
